module.exports = __webpack_public_path__ + "d833636db6850d344f1d777ae028bfe1.svg";